import { boolean, object, string } from "yup";
import { defaultContextFields } from "../../shared.js";
const MAX = 32768;
const tooLong = "Too many characters entered.";
export const bidPart1DataSchema = object({
    ...defaultContextFields(),
    decisionOutline: string()
        .trim()
        .max(MAX, tooLong)
        .required("Please confirm the decision to be made"),
    capacityAssessedCheck: boolean()
        .nullable()
        .default(null)
        .required("Please confirm your answer"),
    powerOfAttorneyOrCourtAppointedDeputy: boolean()
        .nullable()
        .default(null)
        .required("Please confirm your answer"),
    advanceDecision: boolean()
        .nullable()
        .default(null)
        .required("Please confirm your answer"),
    advanceDecisionDetails: string()
        .trim()
        .max(MAX, tooLong)
        .default("")
        .when("advanceDecision", {
        is: true,
        then: (s) => s.required("Please provide details of the advance decision"),
        otherwise: (s) => s.notRequired(),
    }),
    regainCapacity: string()
        .oneOf(["can-wait", "cannot-wait", "unlikely-to-regain"])
        .required("Please confirm your answer"),
    participationSteps: string().trim().max(MAX, tooLong).default(""),
    personsWishes: string().trim().max(MAX, tooLong).default(""),
    consultationViews: string().trim().max(MAX, tooLong).default(""),
    optionsBenefitsRisks: string().trim().max(MAX, tooLong).default(""),
    bestInterestDecisionAndReasoning: string()
        .trim()
        .max(MAX, tooLong)
        .required("Please indicate the Best Interest Decision"),
    otherRelevantInformation: string().trim().max(MAX, tooLong).default(""),
    bestInterestDeclaration: boolean()
        .oneOf([true], "Please confirm the best interest declaration")
        .default(false)
        .required("Please confirm the best interest declaration"),
});
export const exampleBidData = [
    {
        data: {
            decisionOutline: "Whether to consent to elective surgery.",
            capacityAssessedCheck: true,
            powerOfAttorneyOrCourtAppointedDeputy: false,
            advanceDecision: false,
            advanceDecisionDetails: "",
            regainCapacity: "cannot-wait",
            participationSteps: "Spoke with patient with family present.",
            personsWishes: "Patient expressed preference to remain at home.",
            consultationViews: "Consulted with family carer and GP.",
            optionsBenefitsRisks: "Considered surgical and non-surgical options with regard to less restrictive principle.",
            bestInterestDecisionAndReasoning: "Proceed with non-surgical option as it aligns with the patient's wishes.",
            otherRelevantInformation: "",
            bestInterestDeclaration: true,
            user: {
                id: undefined,
                name: "Clinician",
                email: "clinician@example.com",
                address: "Clinic Address",
                postalCode: "AB1 2CD",
                isConfirmed: true,
                isSection12Approved: false,
                isGuest: false,
            },
            patient: {
                name: "Patient",
                address: "Patient Address",
                postalCode: "AB1 2CD",
                dateOfBirth: "1950-01-01",
                nhsNumber: "1234567890",
            },
        },
    },
];
//# sourceMappingURL=bid.js.map